const CurriculumLatestProjectsBox = () => {
  return <div>Hello World from CurriculumLatestProjectsBox</div>;
};

export default CurriculumLatestProjectsBox;
